import { routes as userRoutes } from "./users/routes";
import { routes as roleRoutes } from "./roles/routes";
import { routes as configsRoutes } from "./configs/routes";
import { routes as audittrailRoutes } from "./audittrail/routes";
import { routes as roleRightAssignmentRoutes } from "./role-rights/routes";

export const routes = [

    ...userRoutes('admin' /** url Prefix */),
    ...roleRoutes(`admin` /** url prefix */),
    ...configsRoutes(`admin` /** url prefix */),
    ...roleRightAssignmentRoutes('admin' /** url prefix */),
    ...audittrailRoutes(`admin` /** url prefix */),
];
